import isServer from './isServer';
import _ from 'lodash';

// declare elem for sizing in outside scope
let elem;

if(!isServer) {
  elem = document.createElement('span');
  document.body.appendChild(elem);
  elem.style.position = 'fixed';
  elem.style.top = '-9999px';
  elem.style.left = '-9999px';
  elem.style.visibility = 'hidden';
  global.elem = elem;
}

const memoize = {};

module.exports = function getTextSize(str, stylesObj, overwriteBool) {
  if(!overwriteBool && memoize[str]) {
    return memoize[str];
  }

  const dimensions = {
    height: 0,
    width: 0
  };

  if(isServer) return dimensions;

  // adjust text then update dimensions
  elem.innerText = str;

  if (stylesObj) {
    _.merge(elem.style, stylesObj); // add stylesObj to element style
  }

  dimensions.height = elem.offsetHeight;
  dimensions.width = elem.offsetWidth;

  memoize[str] = dimensions;

  return dimensions;
};



// WEBPACK FOOTER //
// ./shared/lib/getTextSize.js